export var HeaderBehavior;
(function (HeaderBehavior) {
    HeaderBehavior["INLINE"] = "inline";
    HeaderBehavior["STICKY"] = "sticky";
    HeaderBehavior["STICKY_BURGER"] = "sticky_burger";
    HeaderBehavior["UNOBTRUSIVE"] = "unobtrusive";
})(HeaderBehavior || (HeaderBehavior = {}));
export default HeaderBehavior;
//# sourceMappingURL=headerBehavior.js.map